// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"2b0d3830","453":"59284b44","455":"93fe3d9b"}[chunkId] + ".chunk.js";
};